import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=0ac8c948&"
import script from "./InfoModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=0ac8c948&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports